import { Box, Button, Chip, Container, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MobileHeroSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100vw',
  marginLeft: 'calc(-50vw + 50%)',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  }
}));

export const DesktopHeroSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  borderRadius: '24px',
  overflow: 'hidden',
  marginBottom: theme.spacing(4),
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

export const HeroImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
  objectPosition: 'center',
  display: 'block',
  backgroundColor: '#f5f5f5',
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    zIndex: 1,
  },
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  }
}));

export const HeroOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(45deg, rgba(0, 0, 0, 0.6) 0%, rgba(0,0,0,0.3) 100%)',
  zIndex: 2,
}));

export const MobileHeaderOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 3,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  background: 'linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%)',
}));

export const HeroContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 3,
  color: 'white',
  padding: theme.spacing(4),
  maxWidth: '1200px',
  width: '100%',
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const EventInfoSection = styled(Container)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  }
}));

export const StyledTicketCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '16px',
  background: '#ffffff',
  border: '1px solid #e0e0e0',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2.5),
    borderRadius: '12px',
  }
}));

export const CartCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '20px',
  background: '#ffffff',
  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  position: 'sticky',
  top: theme.spacing(2),
  border: '1px solid #e0e0e0',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

export const MobileBottomCart = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#ffffff',
  boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
  zIndex: 1000,
  borderTop: '1px solid #e0e0e0',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  }
}));

export const InfoChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5, 0.5, 0.5, 0),
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '0.875rem',
  height: '36px',
  backgroundColor: '#f5f5f5',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.75rem',
    height: '32px',
    margin: theme.spacing(0.25, 0.5, 0.25, 0),
  },
  '&.location': {
    color: '#2e7d32',
    '& .MuiChip-icon': {
      color: '#2e7d32',
    }
  },
  '&.date': {
    color: '#1565c0',
    '& .MuiChip-icon': {
      color: '#1565c0',
    }
  },
  '&.time': {
    color: '#7b1fa2',
    '& .MuiChip-icon': {
      color: '#7b1fa2',
    }
  }
}));

export const PremiumButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px',
  padding: '10px 20px',
  fontWeight: 600,
  textTransform: 'none',
  background: '#2196f3',
  color: '#ffffff',
  fontSize: '0.875rem',
  '&:hover': {
    background: '#1976d2',
  },
  '&:disabled': {
    background: '#e0e0e0',
    color: '#9e9e9e',
  }
}));

export const QuantityButton = styled(Button)(({ theme }) => ({
  minWidth: '36px',
  width: '36px',
  height: '36px',
  borderRadius: '8px',
  border: '1px solid #e0e0e0',
  color: '#2196f3',
  backgroundColor: '#ffffff',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    border: '1px solid #2196f3',
  }
}));
